import { Component } from "react";

class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV === "development") {
      console.error(error, info);
    }
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <main className="section public-simple-page">
        <section className="container-sm public-simple-card">
          <p className="eyebrow">Zayas Kitchen</p>
          <h1>Something needs a quick refresh.</h1>
          <p className="muted-text">The page ran into an unexpected problem. Try again or return home.</p>
          <div className="flex gap-3 flex-wrap">
            <button className="btn btn-primary" onClick={() => window.location.reload()} type="button">
              Retry
            </button>
            <a className="btn btn-secondary" href={this.props.homeHref || "/"}>
              {this.props.homeLabel || "Go Home"}
            </a>
          </div>
        </section>
      </main>
    );
  }
}

export default AppErrorBoundary;